export const sortByOrder = (a: any, b: any): number => a.order - b.order;
